var base = require('settings/profile/update-contact-information');
import Multiselect from 'vue-multiselect';

Vue.component('spark-update-contact-information', {
    mixins: [base],
    components: {Multiselect},
    props: ['user', 'timeZones'],

    /**
     * The component's data.
     */
    data() {
        return {
            form: new SparkForm({
                email: '',
                dob: '',
                position: '',
                timezone: '',
                business_phone: '',
                phone: '',
                first_name: '',
                last_name: '',
                settings: {},
            }),
        };
    },

    /**
     * Bootstrap the component.
     */
    mounted() {
        this.form.email = this.user.email;
        this.form.dob = this.user.dob;
        this.form.position = this.user.position;
        this.form.timezone = this.user.timezone;
        this.form.business_phone = this.user.business_phone;
        this.form.phone = this.user.phone;
        this.form.first_name = this.user.first_name;
        this.form.last_name = this.user.last_name;
        this.form.settings = _.defaultTo(this.user.settings, {
            email_notification_frequency: null,
        });
    },

    methods: {
        /**
         * Update the user's contact information.
         */
        update() {
            const _this = this;
            Spark.put('/api/users/settings', this.form).then(() => {
                _this.$noty.success('Contact information updated');
            });
        },
    },
});
